// components/HeaderText.tsx
'use client'; 

// import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import LottieLoader from './LottieLoader'; 

// Константы вынесены сюда же
const phrases = [
  // Дождь / осадки
  { text: 'Я подскажу, стоит ли брать зонт.', path: '/animations/rainy.json' },
  { text: 'Проверим осадки по часам — когда лучше выйти без дождя.', path: '/animations/rainy.json' },
  {
    text: 'Скажу, будет ли мокрый снег и стоит ли надеть непромокаемую обувь.',
    path: '/animations/rainy.json',
  },

  // Прогулки / план на день
  { text: 'Узнай, когда лучше выйти на прогулку.', path: '/animations/two-people-thinking.json' },
  { text: 'Подскажу лучшее окно для дел: без ветра, осадков и с комфортной температурой.', path: '/animations/two-people-thinking.json' },
  { text: 'Покажу, когда температура “ощущается как” самая приятная.', path: '/animations/two-people-thinking.json' },

  // Мороз / холод / ветер
  { text: 'На улице мороз? Я подскажу, как одеться потеплее!', path: '/animations/snowy.json' },
  { text: 'Сильный ветер? Подскажу, стоит ли надеть капюшон/шарф.', path: '/animations/snowy.json' },
  { text: 'Гололёд и скользко? Предупрежу, когда риск выше.', path: '/animations/snowy.json' },
  { text: 'Подскажу, когда лучше проветривать: чтобы не выстудить квартиру.', path: '/animations/snowy.json' },

  // Солнце / УФ / тепло
  { text: 'Какой УФ-индекс? Узнай, нужен ли солнцезащитный крем.', path: '/animations/sunny.json' },
  { text: 'Подскажу, когда солнце самое активное — лучшее время для прогулки в тени.', path: '/animations/sunny.json' },
  { text: 'Жарко? Скажу, когда пик жары и когда станет легче.', path: '/animations/sunny.json' },
  { text: 'Подскажу время рассвета и заката — чтобы спланировать фото/прогулку.', path: '/animations/sunny.json' },
];


export const HeaderText = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % phrases.length);
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex-grow text-center md:text-left">
      {/* <motion.h2
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-main text-xl sm:text-2xl md:text-2xl xl:text-3xl font-bold"
      > */}
       <h2 className="text-main text-xl sm:text-2xl md:text-2xl xl:text-3xl font-bold">
        Привет! Я <span className="text-white">- твой умный погодный помощник в Томске.</span>
       </h2>
      {/* </motion.h2> */}

      {/* <AnimatePresence mode="wait">
        <motion.div
          key={phrases[index].text}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.6 }}
          className="flex text-left mt-2 items-center gap-2 text-white text-sm xl:text-base"
          aria-live="polite"
        >
          <div className="w-8 h-8 flex-shrink-0" aria-hidden="true">
            <LottieLoader src={phrases[index].path} className="w-8 h-8" />
          </div>
          <span>{phrases[index].text}</span>
        </motion.div>
      </AnimatePresence> */}
       <div
        key={phrases[index].text}
        className="flex text-left mt-2 items-center gap-2 text-white text-sm xl:text-base min-h-10 transition-opacity duration-300"
        aria-live="polite"
      >
        <div className="w-8 h-8 flex-shrink-0" aria-hidden="true">
          <LottieLoader src={phrases[index].path} className="w-8 h-8" />
        </div>
        <span>{phrases[index].text}</span>
      </div>
    </div>
  );
};
